export default ({ IDL }) => {
  const AccountIdentifier = IDL.Text;
  const TokenIndex = IDL.Nat32;
  const Result_2 = IDL.Variant({ 'ok' : TokenIndex, 'err' : IDL.Text });
  const HeaderField = IDL.Tuple(IDL.Text, IDL.Text);
  const HttpRequest = IDL.Record({
    'url' : IDL.Text,
    'method' : IDL.Text,
    'body' : IDL.Vec(IDL.Nat8),
    'headers' : IDL.Vec(HeaderField),
  });
  const HttpResponse = IDL.Record({
    'body' : IDL.Vec(IDL.Nat8),
    'headers' : IDL.Vec(HeaderField),
    'status_code' : IDL.Nat16,
  });
  const Result = IDL.Variant({ 'ok' : AccountIdentifier, 'err' : IDL.Text });
  return IDL.Service({
    'acceptCycles' : IDL.Func([], [], []),
    'availableCycles' : IDL.Func([], [IDL.Nat], ['query']),
    'claimFreeGift' : IDL.Func([AccountIdentifier], [Result_2], []),
    'confirmDonation' : IDL.Func([AccountIdentifier], [], []),
    'getDonors' : IDL.Func([], [IDL.Vec(AccountIdentifier)], ['query']),
    'getGiftees' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(AccountIdentifier, TokenIndex))],
        ['query'],
      ),
    'http_request' : IDL.Func([HttpRequest], [HttpResponse], ['query']),
    'tipAddress' : IDL.Func([AccountIdentifier], [Result], ['query']),
  });
};
export const init = ({ IDL }) => { return []; };